// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".banner{display:flex;padding:1rem;margin:1rem;align-items:flex-start;justify-content:space-between;border:1px solid #ecf1f9;background:#f9fbfe}\n", ""]);
// Exports
module.exports = exports;
